
export interface GetDocumentsStatusInterface {
    status:        string;
    isProcessing:  string;
    statuses:      Statuses;
    updated:       boolean;
    errorDTO:      ErrorDTO;
    transactionId: string;
}

export interface ErrorDTO {
    errorCode:    string;
    errorMessage: string;
}

export interface Statuses {
    statuses: Status[];
}

export interface Status {
    groupTransactionID: string;
    groupIsProcessing:  string;
    groupStatus:        string;
    documents:          Document[];
}

export interface Document {
    transactionID: string;
    isProcessing:  string;
    status:        string;
}
export enum GetDocumentsStatusUpdateEnum {
    isProcessingReady = '0',
    isProcessingNotReady = '1',
    isPendingStatus = '1',
    isSignedStatus = '2',
    isRejectedStatus = '3',
    isExpiredStatus = '4',
    isFailedStatus = '5',
    isWithdrawnStatus = '6',
    isUndeliverableStatus = '7',
    isOnHoldStatus = '99',
  }